export default function (Vue) {
  const VueFormatTitleize = (value) => {
    return value.replace('_', ' ').replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase() })
  }

  Vue.filter('titleize', VueFormatTitleize)
}



// WEBPACK FOOTER //
// ./src/modules/filters/FormatTitleize.js